// extracted by mini-css-extract-plugin
module.exports = {"errorNotice":"ErrorNotice_errorNotice__2UoDu","errorNotice__icon":"ErrorNotice_errorNotice__icon__16QEz"};